import styled from 'styled-components';

import { colors } from 'ui/theme/colors';

const StyledDivider = styled.hr`
  background: ${colors.grey15};
`;

type Props = Record<string, unknown>;

// https://zeroheight.com/3fe730a39/p/728583-dividers
export const Divider = (props: Props) => <StyledDivider data-test="divider" {...props} />;
